export const statisticSurveys: TableModule = {
    name: "statisticSurveys",
    route: "spa.statistics.statisticSurveys",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "priority",
            sortable: true,
        }, {
            name: "logo",
        }, {
            name: "color",
        }
    ],
    filters: [
    ],
    quickFilters: [
    ],
    tools: [
        {
            name: "statisticSurveys.create",
            isCreateAction: true,
            ability: [
                "create",
                "statisticSurveys"
            ]
        }
    ]
}